import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LtiService } from '../../services/LTI/lti.service';
import { EncryptionService } from '../../../app/services/data/encryption.service';
import { CodResp } from '../../constants/codigosMensajes';
import { CONFIG } from '../../constants/constants';
import { Item } from '../../model/item';
import { SumadiData } from '../../model/lti-launch';
import { SiteApplicationDTO } from "../../model/siteApplication";
import { State } from "../../model/state";
import { TerritoriumDataDTO } from '../../model/territoriumData.dto';
import { Token } from "../../model/token";
import { WelcomeDTO } from "../../model/welcome.info";
import * as html2canvas from "../../../assets/resources/js/html2canvas";
import { AdaptativeService } from "../../services/adaptativeService/adaptative-service";
import { AnswerService } from "../../services/answer/answer.service";
import { AnswerControlService } from '../../services/answer/answerControl.service';
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { DeleteService } from "../../services/data/delete.service";
import { OfflineService } from "../../services/data/offline.service";
import { ItemControlService } from "../../services/item/item-control.service";
import { ItemService } from '../../services/item/item.service';
import { LoginService } from "../../services/login/login.service";
import { RoutingValidationService } from "../../services/routingValidation/routing-validation.service";
import { StateService } from "../../services/state/state.service";
import { TokenService } from "../../services/state/token.service";
import { TokenControlService } from "../../services/state/tokenControl.service";
import { TerritoriumService } from '../../services/territorium/territorium.service';
import { ToolkitService } from "../../services/toolKit/toolkit.service";
import { ValidacionPcService } from '../../services/validacionPC/validacion-pc.service';
import { WelcomeService } from "../../services/welcome/welcome.service";
import { LaunchStudentComponent } from '../LTI-Integration/launchStudent/launchStudent.component';
import { Mask, MaskService } from '../../services/mask/mask.service';
import { Renderer2, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { chatDraggable } from '../../components/draggable-functions/draggable-functions';
import { TYPE_ROLES } from '../../constants/typeRoles';

//Variable del global scope para utilizar jquery
declare var $: any;

//Variable del global scope para funcionamiento de MathJax
declare var MathJax: any;
@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css'],
  providers: [ItemService, DeleteService, AnswerService, TokenService, EncryptionService]
})
export class WelcomeComponent {

  //Objeto que contiene la informacion que se muestra en la pagina
  public welcomeData: WelcomeDTO;

  //Indica si se debe mostrar la seccion para cambio de nombre
  public showChangeName: boolean;

  //Almacena el nuevo nombre para la funcionalida de cambio de nombre
  public newName: string;

  //password ingresado por el usuario para el cambio de nombre
  public passName: string;

  /*Indica si se debe mostrar los mensajes de la validacion
    para el cambio de nombres*/
  public showValidationChangeName: boolean;

  //Token del usuario que se ecuentra presentando el examen
  private token: Token;

  /*Almacena el mensaje que da como resultado la validacion
    realizada en el cambio de nombre*/
  public messageValidationChangeName: string;

  /*flag que dice si se debe indicar la obligatoriedad del nombre
    para la funcionalidad de cambio de nombre*/
  public showRequiredName: boolean;

  //indica si se debe mostrar el boton para el cambio de nombre
  public showButtonChangeName: boolean;

  //Almacena el codigo saber de la insticion
  public codeSaber: string;

  //Indica si se debe mostrar las validaciones del nombre
  public showValidationName: boolean;

  /*objeto que contiene la informacion del sitio en que
    se realiza la prueba*/
  public siteApplicationDTO: SiteApplicationDTO;

  //indica si se debe mostrar las validaciones para el codigo saber
  public showValidationCodeSaber: boolean;

  //Indica si se debe mostrar el inicio de la primera sesion
  //public showInicioPrimeraSesion: boolean;

  //Almacena el codigo saber de base de datos
  public codeSaberBD: string;

  //Representa la accion del boton de inicio
  private actionButton: string;

  /*flag que dice si se debe indicar la obligatoriedad del nombre
    para la funcionalidad de cambio de nombre*/
  public showRequiredInstitution: boolean;

  /** Atributo que indica la sessión que se ha iniciado.*/
  public sesionNumero: number;

  //Mensaje salida error modal.
  public mensaje: string;

  public showNameWatemark: Boolean;

  public sesionsData: WelcomeDTO;

  //indica si finalizo de alamacenar en cache las imagenes
  public finalizoCache: Boolean = false;

  //indica si finalizo de alamacenar los items en la base de datos local
  public finalizoGuardadoItems: Boolean = false;

  //indica si finalizo de alamacenar los formulas mathjax en la base de datos local
  public finalizoGuardadoFormulas: Boolean = false;

  /** Flag para habilitar boton de accion al cargar los items */
  public activateStart: Boolean;

  /** Flag para habilitar la insercion del script de chat */
  public conChat: Boolean;

  /** Indica si debe tener vigilancia con territorium */
  public conSecurityTerritorium: Boolean;

  /** Indica si posee permisos de audio y video */
  public conPermisosTerritorium: Boolean = false;

  /** Indica si debe tener vigilancia con Sumadi */
  public isSumadiActive: Boolean;

  public nombreEst: String;
  public idEst: number;

  public nombrePruebas: String;
  public nombreEvaluacion: String;

  @ViewChild(LaunchStudentComponent, { static: false }) launchStudentComponent: LaunchStudentComponent;


  //Constructor de la clase
  constructor(private _router: Router,
    private _itemService: ItemService,
    public _tokenController: TokenControlService,
    private _answerController: AnswerControlService,
    public _welcomeDataService: WelcomeService,
    private _stateService: StateService,
    private _deleteService: DeleteService,
    private _answerService: AnswerService,
    private _translateService: TranslateService,
    private _adaptiveService: AdaptativeService,
    public _itemControlService: ItemControlService,
    private _configurationService: ConfigurationService,
    private _configurationControlService: ConfigurationControlService,
    private _spinner: NgxSpinnerService,
    private _loginService: LoginService,
    private _routingValidationService: RoutingValidationService,
    private _toolkitService: ToolkitService,
    private _encryptionService: EncryptionService,
    private _offlineService: OfflineService,
    private _validacionPcService: ValidacionPcService,
    private _territoriumService: TerritoriumService,
    private _ltiService: LtiService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private _maskService: MaskService

  ) {
    this._spinner.show();
    this._itemService.initDb();
    this.welcomeData = this._welcomeDataService.data;
    this.showChangeName = false;
    this.showValidationChangeName = false;
    let self = this;
    self.token = _tokenController.token;
    this.messageValidationChangeName = null;
    this.passName = null;
    this.newName = null;
    this.showRequiredName = false;
    this.showButtonChangeName = false;
    this.codeSaber = null;
    this.showValidationCodeSaber = false;
    this.showRequiredInstitution = false;
    this.siteApplicationDTO = new SiteApplicationDTO(0, "", "", "", "");
    this.codeSaberBD = this.welcomeData.saberCode;
    this._translateService.addLangs(["es", "en"]);
    this._translateService.setDefaultLang(_configurationControlService.examConfiguration.language);
    this._translateService.use(_configurationControlService.examConfiguration.language);
    this.translateButtonLabels();
    this._spinner.hide();
    this.showNameWatemark = true;
    this.sesionNumero = 0;
    this.activateStart = false;
    this.nombreEst = this._welcomeDataService.data.fullName;
    this.idEst = this._tokenController.token.credentialId;

  }

  public getNameTest() {
    if (this._tokenController.isRoleReview()) {
      return "Exhibición"
    }
    return this.welcomeData.test
  }

  public translateButtonLabels() {
    let self = this;
    for (let session of this.welcomeData.sessions) {
      this._translateService.get('boton.' + session.buttonAction).subscribe((res: string) => {
        session.buttonAction = res;
      });
    }
    this._translateService.get('boton.Iniciar').subscribe((result: string) => {
      self.actionButton = result;
    });
  }

  getLabelName(session) {
    if (this.finalizoAlamcenamientoLocal()) {
      if (this.isSumadiActive && session.supervised && !session.disabledButton) {
        if (this.welcomeData.aplicationType == 'Demo') {
          return 'Preregistro biometrico';
        } else {
          return 'Validación fotografica'
        }
      } else {
        return session.buttonAction;
      }
    } else {
      return 'Cargando ...';
    }
  }

  private checkDirectEnter() {
    if (this.isSumadiActive) {
      if (this._ltiService.idSessionStart) {
        const session = this.sesionsData.sessions.find(s => s.id == this._ltiService.idSessionStart);
        this.validateStartExam(session);
      } else {
        this._maskService.setMask(Mask.fullPageMask, false);
      }
    }
  }

  ngOnInit() {
    this._configurationService.inhabilitarBotonAtras();
    this.sesionsData = this._welcomeDataService.data;
    let self = this;
    this.renderExam();
    $(document).ready(() => {
      $('[data-toggle="tooltip"]').tooltip();
    });

    this.conChat = this._configurationControlService.examConfiguration.conChat;
    this.conSecurityTerritorium && this.prepareTerritoriumIntegration();
    this.conChat && setTimeout(() => this.includeChat(), 2500);
    this.isSumadiActive = this._configurationControlService.examConfiguration.securitySumadi;
    this.isSumadiActive && this.prepareSumadiInformation();
    if (CONFIG.ONLINE) {
      self.loadItemsExam();
    } else {
      self.loadItemsOffline();
    }
  }


  prepareSumadiInformation(): any {
    this._welcomeDataService.ltiInformation = Object.assign({}, this._welcomeDataService.data);
    this._welcomeDataService.ltiInformation.tokenId = this._tokenController.token.tokenId;
    this._welcomeDataService.ltiInformation.credentialId = this._tokenController.token.credentialId;
    if (this._welcomeDataService.ltiInformation.identificacion) {
      this._welcomeDataService.ltiInformation.identificacion = this._welcomeDataService.ltiInformation.identificacion.substr(2);
    }
    console.log("su_prepareSumadiInformation", this._welcomeDataService.ltiInformation)
    this.checkSupervisedSessions();
    var idVar = setInterval(() => {
      if (this.finalizoAlamcenamientoLocal()) {
        this.checkDirectEnter();
        clearInterval(idVar);
      }
    }, 500);
  }

  public checkSupervisedSessions() {

    const stringSaved = this._ltiService.sumadiData.split('*UuvuU*');

    const { sessions }: SumadiData =
      JSON.parse(this._encryptionService.decryptDataSumadi(stringSaved[0], stringSaved[1]));

    this.sesionsData.sessions.forEach(sesion => {
      if (!sessions.includes(sesion.id)) {
        sesion.supervised = true;
      } else {
        sesion.supervised = false;
      }
    });

  }

  public finalizoAlamcenamientoLocal() {
    return this.finalizoCache && this.finalizoGuardadoItems && this.finalizoGuardadoFormulas;
  }


  prepareTerritoriumIntegration(): void {
    $.getScript("https://icfes.edtest.ai/resources/js/vue.min.js", function (data, estado) {
      if (estado != 'success') {
        alert("Error cargando https://icfes.edtest.ai/resources/js/vue.min.js");
        location.reload();
      }
    });

    navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(
      stream => this.conPermisosTerritorium = true,
      e => {
        $('#permissionErrorTerritorium').modal({ show: true });
        this.conPermisosTerritorium = false;
      }
    );
    this.loadTerritoriumData();
  }

  private includeChatTerritorium() {
    $.getScript("/src/app/resources/js/chatTerritorium.js", function (data, estado) {
      if (estado == 'success') {
        console.log("Cargado script chatTerriturium");
      }
      else {
        alert("Error al cargar script chatTerriturium");
      }
    });
  }

  loadTerritoriumData(): void {
    const CREDENCIAL = this._tokenController.token.credentialId + "";
    const TOKEN = this._tokenController.token.token;
    const USERNAME = this._tokenController.token.tokenId;
    this._territoriumService.getTerritoriumData(CREDENCIAL, TOKEN, USERNAME)
      .subscribe((response: TerritoriumDataDTO) => {
        this._welcomeDataService.data.idTerritorium = response.idTerritorium;
      }, e => console.error('ha ocurrido un error al consultar el id de territorium'));
  }

  verificarEstadoTerritorium(): Boolean {
    return (this.conPermisosTerritorium && this._welcomeDataService.data.idTerritorium) ? false : true;
  }

  private includeChat() {
    $.getScript("src/assets/chat.js", function (data, estado) {
      if (estado == 'success') {
        console.log("Cargado script chat");

        setInterval(() => {
          //PE-3619 Dragg and drop
          //Valida los movimientos de los eventos mousemove y mouseup para el control del dragg and drop
          chatDraggable("amazon-connect-chat-widget");

        }, 100);

      }
      else {
        alert("Error al cargar la librería autocomplete");
      }
    });
  }

  desencriptarSession(datosGuardados: any) {
    let self = this;
    var arrayFilas: string[][];
    let encriptado = datosGuardados[0] + datosGuardados[1] + datosGuardados[2]
    arrayFilas = encriptado.split("_VVVVV_");
    var vector = arrayFilas[0];
    var llave = arrayFilas[1];
    var contenidoEncrip = new String(arrayFilas[2]);

    if (vector != null && llave != null && contenidoEncrip != null) {
      var llaveK: CryptoKey;
      var vector1: any = JSON.parse("[" + vector + "]");
      window.crypto.subtle.importKey(
        "jwk",
        {
          kty: "oct",
          k: llave.toString(),
          alg: "A128CBC",
          ext: true,
        },
        "AES-CBC",
        true,
        ["encrypt", "decrypt"]
      ).then(function (key: any) {
        llaveK = key;
        self._encryptionService.decrypt_data_File(contenidoEncrip, Uint8Array.from(vector1), key).then(result => {
          let objetoDesecriptado: any = JSON.parse(result);
          self._answerService.resolveAnswersFromLocal(self._tokenController.token.credentialId.toString(), objetoDesecriptado.answers).then(state => {
            self._stateService.state = state;
            self._stateService.previousTime = objetoDesecriptado.crono;
            self._tokenController.token.sesion = state.sesion;
            self._itemService.saveState(state);
            self.validarBotonInicioOffline();
            if (self._configurationControlService.examConfiguration.hideWelcome) {
              self.inicializarItemsAdaptativo(null);
              self._routingValidationService.validateRouting("login2Exam");
            }
            self.activateStart = true;
          })
        }).catch(err => {
          console.log("err encriptandon el archivo  = " + err);
        });
      });
    }
  }

  esUsuarioConSessionPrevia(credencial: string) {
    return JSON.parse(window.localStorage.getItem(credencial));
  }

  /**Metodo encargado de convertir el String de pruebas en una lista */
  public renderExam() {
    for (let i = 0; i < this.sesionsData.sessions.length; i++) {
      let session = this.sesionsData.sessions[i];
      for (let j = 0; j < session.subjects.length; j++) {
        let namePrueba: string = session.subjects[j].name;
        if (namePrueba.startsWith("-")) {
          namePrueba = namePrueba.substring(1, namePrueba.length);
        }
        if (namePrueba.includes("-")) {
          let pruebas = namePrueba.split("-");
          this.sesionsData.sessions[i].subjects[j].name = pruebas;
        } else {
          this.sesionsData.sessions[i].subjects[j].name = [];
          this.sesionsData.sessions[i].subjects[j].name.push(namePrueba)
        }
      }
    }
  }

  /** Metodo encargado de crear la iamgen para marca de agua */
  public loadWateMark() {
    let self = this;
    // Obteniendo la etiqueta la cual se desea convertir en imagen
    var domElement = document.getElementById("name");

    // Utilizando la función html2canvas para hacer la conversión
    html2canvas(domElement).then(function (domElementCanvas) {
      // Obteniendo el contexto del canvas ya generado
      var context = domElementCanvas.getContext('2d');
      // Creando enlace para descargar la imagen generada
      var link = document.createElement('a');
      link.href = domElementCanvas.toDataURL("image/png");
      link.download = "imagen.png";
      self._welcomeDataService.waterMark = link.href;
      self.showNameWatemark = false;
    })
  }

  private obtenerRecursos(items: Item[]) {
    const itemRecursos = [];
    items.map((item) => {
      if (item.recursosItem != null && item.recursosItem != undefined) {
        let arrayRecurso = [];
        try {
          arrayRecurso = JSON.parse(item['recursosItem'].toString());
        } catch (e) { console.error(e) }
        for (let i = 0; i < arrayRecurso.length; i++) {
          const recurso = arrayRecurso[i];
          if (itemRecursos.indexOf(recurso) == -1) {
            itemRecursos.push(recurso)
          }
        }
      }
    });

    return itemRecursos;
  }

  private guardarCaheImages(items: Item[]) {
    this.finalizoCache = false;
    if (CONFIG.ONLINE) {
      const tInicio = (new Date()).getMilliseconds();
      const recursosUnicos = this.obtenerRecursos(items);
      this._welcomeDataService.loadServiceWorkerAll(recursosUnicos).then(value => {
        this.finalizoCache = true;
        console.log("finalizo .. carga cache-image" + ((new Date()).getMilliseconds() - tInicio))
      });
    } else {
      this.finalizoCache = true;
      console.log("finalizo .. carga cache-image")
    }
  }

  private extraerFormulaMathJax(item: Item) {
    return new Promise<void>((resolve, reject) => {
      this._encryptionService.decrypt_Item(item.content)
        .then((contentDecrypted: string) => {
          const formulas = contentDecrypted.match(/\$.+\$+/g);
          if (formulas && formulas.length > 0) {
            this.renderFormulaMathJax(contentDecrypted)
              .catch(() => { resolve(); })
              .then(() => { resolve(); });
          } else { resolve(); }
        })
    });
  }

  private renderFormulaMathJax(contenidoItem: string) {
    return new Promise<void>((resolve, reject) => {
      try {
        const htmTemporal = $(`<div>${contenidoItem}</div>`).find("img").removeAttr("src");
        MathJax.Hub.Queue(["Typeset", MathJax.Hub, htmTemporal[0]],
          () => { resolve(); });
      } catch (error) {
        reject();
      }
    });
  }

  private guardarFormulasMathJax(items: Item[]) {
    if (CONFIG.ONLINE) {
      const arryItems = [];
      const tInicio = (new Date()).getMilliseconds();
      this.finalizoGuardadoFormulas = false;
      items.map((item: Item) => {
        arryItems.push(this.extraerFormulaMathJax(item))
      });
      Promise.all(arryItems)
        .catch(() => {
          this.finalizoGuardadoFormulas = true; console.log("finalizo carga formula mathjax " + ((new Date()).getMilliseconds() - tInicio));
        })
        .then(() => {
          this.finalizoGuardadoFormulas = true; console.log("finalizo carga formula mathjax " + ((new Date()).getMilliseconds() - tInicio))
        })
    } else {
      this.finalizoGuardadoFormulas = true;
    }
  }

  private guardarItems(items: Item[]) {
    this.finalizoGuardadoItems = false;
    const tInicio = (new Date()).getMilliseconds();
    this._itemService.addItemsAll(items)
      .then(() => {
        this.finalizoGuardadoItems = true;
        console.log("finalizo guardado items " + ((new Date()).getMilliseconds() - tInicio))
      })
      .catch(() => {
        this.finalizoGuardadoItems = true;
        console.log("finalizo guardado items " + ((new Date()).getMilliseconds() - tInicio))

      })
  }


  /*Necesario debido a la implementacion de la interfaz AfterViewInit
    se ejecuta despues de inicializada la vista */
  loadItemsExam() {
    let self = this
    this._itemService.actualizarAllRevisionRespuestas(false)
    $('[data-toggle="tooltip"]').tooltip();
    self._itemService.getState().then(res => {
      if (res == null || res == undefined) {
        self._itemService.resolveItems(
          this._tokenController.token.tokenId,
          this._tokenController.token.token).then(items => {
            self.guardarCaheImages(items);
            self.guardarItems(items);
            self.guardarFormulasMathJax(items);
            self._answerController.totalItems = items.length;
            self._answerService.resolveAnswers(
              self._tokenController.token.tokenId,
              self._tokenController.token.token,
              self._tokenController.token.credentialId).then(state => {
                self._itemService.saveState(state);
                self._stateService.state = state;
                self.validarBotonInicio();
                if (self._configurationControlService.examConfiguration.hideWelcome) {
                  self.inicializarItemsAdaptativo(null);
                  self._routingValidationService.validateRouting("login2Exam");
                }
                self.activateStart = true;
              });
          });
      } else {
        this._deleteService.deleteTablesChangeUser().then(resp => {
          this._itemService.resolveItems(
            this._tokenController.token.tokenId,
            this._tokenController.token.token).then(items => {
              self.guardarCaheImages(items);
              self.guardarItems(items);
              self.guardarFormulasMathJax(items);
              self._answerController.totalItems = items.length;
              this._answerService.resolveAnswers(
                this._tokenController.token.tokenId,
                this._tokenController.token.token,
                this._tokenController.token.credentialId)
                .then(state => {
                  self._itemService.saveState(state);
                  self._stateService.state = state;
                  self.validarBotonInicio();
                  if (self._configurationControlService.examConfiguration.hideWelcome) {
                    self.inicializarItemsAdaptativo(null);
                    self._routingValidationService.validateRouting("login2Exam");
                  }
                });
              self.activateStart = true;
            });
        }
        );
      }
    });
    setTimeout(function () {
      if (!self._configurationControlService.esDemo) {
        self.loadWateMark();
      }
    }, 5)
  }

  loadItemsOffline() {
    let self = this;

    $('[data-toggle="tooltip"]').tooltip();
    self._itemService.getState().then(res => {
      self._offlineService.getItems(
        self._tokenController.token.tokenId,
        self._tokenController.token.token).then(listaItems => {
          self.guardarCaheImages(listaItems);
          self.guardarItems(listaItems);
          self.guardarFormulasMathJax(listaItems);
          const credencial = this._tokenController.token.credentialId.toString();
          const datosGuardados = this.esUsuarioConSessionPrevia(credencial);
          if (datosGuardados) {
            this.desencriptarSession(datosGuardados);
          }
          if (!datosGuardados) {
            let session = this._stateService.state ? this._stateService.state.sesion : 1;
            self._itemService.saveState(new State(1, session, 1,
              self._tokenController.token.credentialId));
            //self.validarBotonInicio();
            if (self._configurationControlService.examConfiguration.hideWelcome) {
              self.inicializarItemsAdaptativo(null);
              self._routingValidationService.validateRouting("login2Exam");
            }
            self.activateStart = true;
          }
        });
    })

    setTimeout(function () {
      if (!self._configurationControlService.esDemo) {
        self.loadWateMark();
      }
    }, 5)
  }


  //Se encarga de navegar hacia el tour de ayuda para iniciar el examen
  public startExam() {
    $('#loginModal').modal({
      show: 'false'
    });

    let self = this;

    if (self._configurationControlService.examConfiguration.singleSession) {
      this._loginService.changeSessionState(self._tokenController.getTokenValue(), self._tokenController.token.tokenId, self._tokenController.token.credentialId.toString(), Number(1), self._configurationControlService.sessionInfo).then((res: any) => {
        let result = res == CodResp[0].codigo ? 'S' : 'N';
        if (result == 'S') {
          console.log("Actualizó sesión única");
        }
      });
    }

    if (self._configurationControlService.examConfiguration.showTerms != null) {
      setTimeout(function () {
        self._router.navigate(['/terms']);
      }, 500);
    } else {
      setTimeout(function () {
        self._router.navigate(['/webTourOne']);
      }, 500);
    }
  }


  //Se encarga de preparar la vista para el cambio de nombre
  public changeName() {
    this.showRequiredName = false;
    this.showValidationCodeSaber = false;
    this.showChangeName = true;
    this.newName = this.welcomeData.fullName;
    this.codeSaber = this.welcomeData.saberCode;
  }


  //Se encarga de restaurar la vista luego del cambio de nombre
  public clearChangeName() {
    this.showRequiredName = false;
    this.showValidationCodeSaber = false;
    this.showButtonChangeName = true;
    this.passName = null;
    this.showChangeName = false;
    this.newName = null;
    this.showValidationChangeName = false;
    this.messageValidationChangeName = '';
    this.showRequiredName = false;
    if (this.codeSaber != this.codeSaberBD) {
      this.welcomeData.daneCode = null;
      this.welcomeData.institution = null;
      this.welcomeData.saberCode = null;
      this.welcomeData.modality = null;
    }
    this.codeSaber == null;
  }


  //Se encarga de guardar el cambio de nombre
  public saveChaneName() {
    let self = this;
    this.showValidationChangeName = false;
    this.messageValidationChangeName = '';
    if (this.newName != null && this.newName != undefined
      && this.newName.trim() != '' && this.passName != null) {

      if (!self.welcomeData.credentialSlack ||
        (self.welcomeData.credentialSlack
          && self.welcomeData.saberCode != null
          && self.welcomeData.saberCode.trim() != ''
          && self.welcomeData.saberCode.toLocaleLowerCase() == this.codeSaber.toLocaleLowerCase())) {
        this.newName = this.newName.trim();
        this.newName = this.newName.toUpperCase();
        if (this.passName == CONFIG.PASSWORD_CHANGE_NAME) {
          this._welcomeDataService.changeUserName(this.token.token,
            this.token.credentialId,
            this.newName, self.welcomeData.saberCode,
            this.token.tokenId)
            .then((res: any) => {
              let result = res == CodResp[0].codigo ? 'S' : 'N';
              if (result == 'S') {
                self.welcomeData.fullName = self.newName;
                self.showChangeName = false;
                self.newName = null;
                self.passName = null;
                this.showValidationChangeName = false;
                this.messageValidationChangeName = '';
                this.codeSaberBD = this.welcomeData.saberCode;
              }
            });
        } else {
          self.showValidationChangeName = true;
          this._translateService.get('mensaje.cambio.nombre.clave.erronea')
            .subscribe((res: string) => {
              self.messageValidationChangeName = res;
            });
        }
      } else {

        if (self.welcomeData.credentialSlack
          && self.welcomeData.saberCode == null
          || (self.welcomeData.saberCode != null
            && self.welcomeData.saberCode.trim() == '')) {
          self.showValidationChangeName = true;
          this._translateService.get('mensaje.cambio.nombre.codigo.saber.error')
            .subscribe((res: string) => {
              self.messageValidationChangeName = res;
            });
        } else if (self.welcomeData.saberCode != this.codeSaber) {
          self.showValidationChangeName = true;
          this._translateService.get('mensaje.cambio.nombre.codigo.saber.requerido')
            .subscribe((res: string) => {
              self.messageValidationChangeName = res;
            });
        }
      }
    } else {
      this.showValidationChangeName = true;
      if (this.newName == null
        || this.newName.trim() == ''
        || this.newName == undefined) {
        this._translateService.get('mensaje.cambio.nombre.nombre.requerido')
          .subscribe((res: string) => {
            self.messageValidationChangeName = res;
          });
      } else if (this.passName == null) {
        this._translateService.get('mensaje.cambio.nombre.password.requerido')
          .subscribe((res: string) => {
            self.messageValidationChangeName = res;
          });
      }
    }
    this.showButtonChangeName = true;
    this.showChangeName = true;
    this.showRequiredName = false;
    this.showValidationCodeSaber = false;
  }



  /*Se encarga de consultar los datos del sitio
    segun el codigo dane ingresado*/
  public findSiteApplication() {
    let self = this;
    self.showValidationCodeSaber = false;
    self.showValidationChangeName = false;
    this._welcomeDataService.queryApplicationSite(
      this.token.token, this.codeSaber, this.token.tokenId).then(res => {
        self.siteApplicationDTO = res;
        if (self.siteApplicationDTO != null) {
          self.welcomeData.daneCode = self.siteApplicationDTO.daneCodeSede;
          self.welcomeData.institution = self.siteApplicationDTO.nombreSede;
          self.welcomeData.saberCode = self.siteApplicationDTO.saberCode;
          self.welcomeData.modality = self.siteApplicationDTO.modality;
        } else {
          self.showValidationChangeName = true;
          this.messageValidationChangeName = "El código saber no es válido";
        }
      });
  }


  /*Se encarga de recorrer las sesiones del examen y
    habilitar los botones de inicio segun el estado del examen*/
  public validarBotonInicio() {
    let self = this;
    this.showButtonChangeName = false;

    for (let entry of this.welcomeData.sessions) {
      if (Number(entry.order) == 1
        && entry.buttonAction == self.actionButton
        && entry.disabledButton == false) {
        this.showButtonChangeName = true;
        if (this._stateService.state != null
          && this._stateService.state.sesion == 1) {
          this._stateService.state.item = 1;
        }
      }
    }

  }

  public validarBotonInicioOffline() {
    this.showButtonChangeName = false;
    for (let entry of this.welcomeData.sessions) {
      if (this._stateService.state.sesion == +entry.order) {
        entry.disabledButton = false;
        entry.buttonAction = "Continuar";
      } else {
        entry.disabledButton = true;
      }
    }

  }

  /*Se encarga de realizar las validaciones necesarias
  para que la persona pueda iniciar el examen*/
  public validateStartExam(sesion: any) {
    this.nombreEvaluacion = sesion.subjects[0].name;
    this.nombrePruebas = sesion.name + ' sesión de la prueba.  Con ' + sesion.subjects[0].totalItems +
      " items y " + sesion.subjects[0].subjectDuration + " minutos";
    if (this.isSumadiActive && sesion.supervised) {
      this.saveSessionClicked(sesion);
      return;
    }
    this._spinner.show();
    this.sesionNumero = parseInt(sesion.order) - 1;
    this.showRequiredName = false;
    this.showValidationCodeSaber = false;

    if (this.welcomeData.fullName == null
      || this.welcomeData.fullName.trim() == ''
      || this.welcomeData.fullName == undefined) {
      this.showRequiredName = true;
    } else if (this.welcomeData.aplicationType == 'SB359' && (this.welcomeData.institution == null
      || this.welcomeData.institution.trim() == ''
      || this.welcomeData.institution == undefined)) {
      this.showRequiredInstitution = true;
    } else {

      if (sesion.buttonAction == 'Iniciar') {
        this._configurationControlService.continuarExamen = false;
        if (this._configurationControlService.examConfiguration.typeTest == '2') {
          this.inicializarItemsAdaptativo(sesion);
          return
        } else {
          this._spinner.hide();
        }

        this.validarRedireccionamiento(sesion);

      } else if (sesion.buttonAction == 'Continuar') {
        this._configurationControlService.continuarExamen = true;
        this.validarContinuar(sesion);
      }
      this.showRequiredName = false;
      this.showValidationCodeSaber = false;
      this.showRequiredInstitution = false;
    }
  }

  private saveSessionClicked(sesion: any) {
    try {
      const stringSaved = this._ltiService.sumadiData.split('*UuvuU*');

      const sumadiData: SumadiData = JSON.parse(this._encryptionService.decryptDataSumadi(stringSaved[0], stringSaved[1]));

      if (!sumadiData.sessions.includes(sesion.id)) {

        sumadiData.sessions.push(sesion.id);

        const encriptedData = this._encryptionService.encryptDataSumadi(JSON.stringify(sumadiData), stringSaved[1]);

        this._welcomeDataService.ltiInformation.session = sesion.id;
        this._welcomeDataService.ltiInformation.returnUrl = `${location.origin}?sumadiData=${encodeURIComponent(encriptedData)}*UuvuU*${stringSaved[1]}`;
        console.log(this._welcomeDataService.ltiInformation.returnUrl);
        this.launchStudentComponent.startLaunch();

      }
    } catch (error) {
      throw new Error(error);
    }
  }

  /**
   * Método que se encarga
   * @param sesion
   */
  private validarRedireccionamiento(sesion: any) {
    if (this._configurationControlService.examConfiguration.multiplesesion) {
      if (sesion.order == 1) {
        $('#loginModal').modal({ show: 'true' });
      } else {
        this._configurationControlService.examConfiguration.showSimulation = false;
        this._configurationControlService.examConfiguration.showTerms = null;
        this._routingValidationService.validateRouting("welcomeToExam");
      }
    } else {
      $('#loginModal').modal({ show: 'true' });
    }
  }

  /**
   * Método que se encarga de validar cual es el siguiente item si ya se había iniciado la prueba,
   */
  private validarContinuar(sesion: any) {
    if (this._configurationControlService.examConfiguration.typeTest == '2') {
      this._adaptiveService.continuarExamen(this._tokenController.token.credentialId.toString(),
        this.sesionNumero,
        this._tokenController.token.tokenId,
        this._tokenController.token.token).then(res => {
          if (res != null && res.idItem != null && res.idItem != "") {
            this._itemService.resolveItemByCode(res.idItem,
              this._tokenController.token.token,
              this._tokenController.token.tokenId,
              sesion.order).then(
                result => {
                  if (result) {
                    this._itemControlService.item = result;
                    this._itemControlService.item.orderVisual = res.numeroPregunta;
                    this._itemControlService.itemCode = res.idItem;
                    this.navegarRuta(sesion);
                    this._spinner.hide();
                  } else {
                    this.mensaje = "El item consultado: " + res.idItem + " no se encuentra disponible.";
                    $('#adaptiveErrorModal').modal({ show: true });
                    this._spinner.hide();
                  }
                }
              );
          } else {
            this.validarCodigoAdaptativa(res);
          }
        });
    } else if (this._configurationControlService.examConfiguration.typeTest == '1') {
      this.navegarRuta(sesion);
      this._spinner.hide();
    }
  }

  /**
   *
   * @param sesion Método que se encarga de redirigir dependiendo si es prueba adaptativa o no.
   */
  public navegarRuta(sesion: any) {
    switch (sesion.buttonAction) {
      case "Continuar":
        this._configurationControlService.startChrono = true;
        if (this._configurationControlService.examConfiguration.typeTest == '2') {
          this._router.navigate(['/viewtestAdp']);
        } else {
          this._router.navigate(['/viewtest']);
        }
        break;
    }
  }

  /**
   * Método que se encarga de llamar al rest para la inicialización de las sesiones.
   */
  public inicializarItemsAdaptativo(sesion: any) {
    let self = this;
    this._adaptiveService.initializeExam(this._tokenController.token.credentialId.toString(),
      this.sesionNumero,
      this._tokenController.token.tokenId,
      this._tokenController.token.token).then(res => {
        var ordenSesion: any;
        if (sesion == null) {
          ordenSesion = this.sesionNumero + 1;
        } else {
          ordenSesion = sesion.order;
        }
        if (res != null && res.idItem != null && res.idItem != "") {
          this._itemService.resolveItemByCode(res.idItem,
            this._tokenController.token.token,
            this._tokenController.token.tokenId, ordenSesion.toString()).then(
              result => {
                self._itemControlService.item = result;
                self._itemControlService.item.orderVisual = res.numeroPregunta;
                self._itemControlService.itemCode = res.idItem;
                self._spinner.hide();
                if (sesion != null) {
                  self.validarRedireccionamiento(sesion);
                }
              }
            );
        } else {
          this.validarCodigoAdaptativa(res);
          $('#loginModal').modal({ show: 'false' });
          $('#loginModal').modal('hide');
        }
      });
  }

  /**
   * Método que se encarga de cerrar la sesión.
   */
  public endAdaptive() {
    $('#adaptiveErrorModal').modal({ show: false });
    $('#adaptiveErrorModal').modal('hide');
    this._router.navigate(['/']);
  }

  /**
   * Método que se encarga de validar
   */
  private validarCodigoAdaptativa(res: any) {
    if (res.codigo == "10") {
      this.mensaje = "El estudiante ya ha terminado la prueba. Se cerrará la sesión."
    } else {
      this.mensaje = "Se ha presentado un error en la aplicación. Se cerrará la sesión. Por favor "
        + " contactarse con el aplicador. Código: " + res.codigo;
    }
    $('#adaptiveErrorModal').modal({ show: true });
    this._spinner.hide();
  }
}


